/** Shape API /user/towlot_catalog into camelCase fields used across the app (single place for key mapping). */

const pickStatusEnum = (apiEnum) =>
  apiEnum ? ({
    SYNCED: apiEnum.SYNCED,
    FAILED: apiEnum.FAILED,
    SOLD: apiEnum.SOLD,
    LISTED: apiEnum.LISTED,
    UNSOLD: apiEnum.UNSOLD,
    WITHDRAWN: apiEnum.WITHDRAWN
  }) : null;

export const normalizeTowlotCatalog = (tc) => {
  if (!tc) return null;

  return {
    towlotColors: tc.colors,
    towlotColorAliases: tc.color_aliases,
    towlotCarTitles: tc.car_titles,
    towlotCarTypes: tc.car_types,
    towlotKeysTypes: tc.keys_types,
    towlotTransmissions: tc.transmissions,
    towlotExterior: tc.exterior,
    towlotInterior: tc.interior,
    towlotMechanical: tc.mechanical,
    towlotOptions: tc.options,
    towlotTermsOfSale: tc.terms_of_sale,
    suggestedDaysForAuction: tc.suggested_days_for_auction,
    towlotStatuses: pickStatusEnum(tc.towlot_statuses),
    towlotStatusLabels: tc.towlot_status_labels,
    towlotStatusFilterOptions: tc.towlot_status_filter_options
  };
};
